import { render, staticRenderFns } from "./editMiniapp.vue?vue&type=template&id=98ac8302&"
import script from "./editMiniapp.vue?vue&type=script&lang=js&"
export * from "./editMiniapp.vue?vue&type=script&lang=js&"
import style0 from "./editMiniapp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports